

import { useEffect } from "react"
import { useRef } from "react"
import { useState } from "react"
import ReactJson from 'react-json-view'
import { AiOutlineAudio, AiOutlineAudioMuted, AiOutlineSend } from "react-icons/ai";
import { useInView } from "react-intersection-observer";
import { FaRegTrashCan } from "react-icons/fa6";
import { commonUtils } from '@centivo-business/utils'
import AIMessage from "./AIMessage";
import HumanMessage from "./HumanMessage";
import { keepPreviousData, useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import { useLoaderData, useNavigate, useNavigation, useParams, useRouteLoaderData, useSearchParams } from "react-router";
import { queryClient } from "../../App";
import { TbEdit } from "react-icons/tb";
import ChatInput from "./ChatInput";
import Select from 'react-select';

const startAudio = new Audio('./../../assets/start.mp3');
const endAudio = new Audio('./../../assets/end.mp3');
const decoder = new TextDecoder();

const FinanceChatbot = () => {

    // const chatDetails = useLoaderData();
    const chatMessages = useRouteLoaderData("getFinanceStateByThreadId");
    const navigation = useNavigation();

    // if (navigation.state === "loading") {
    //     return <p></p>;
    // }

    // const [textInput, setTextInput] = useState('')
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false)
    const [isListening, setIsListening] = useState(false);
    const [messages, setMessages] = useState(chatMessages || [])
    const [errorMessage, setErrorMessage] = useState()

    const [selectedClientId, setSelectedClientId] = useState(null)
    const [selectedPlanId, setSelectedPlanId] = useState(null)


    const [searchParams, setSearchParams] = useSearchParams();
    const params = useParams()
    const navigate = useNavigate()

    const { ref, inView } = useInView();

    useEffect(() => {
        if (chatMessages) {
            setMessages(chatMessages)
        }
    }, [navigation.state, chatMessages])

    // const [threadId, setThreadId] = useState('')

    // console.log({ params, chatDetails, routerData, navstate: navigation.state })
    const threadId = params.threadId // searchParams.get('threadId')

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = SpeechRecognition ? new SpeechRecognition() : null;

    useEffect(() => {
        if (recognition) {

            recognition.InitialSilenceTimeout = 1000
            recognition.EndSilenceTimeout = 2000
            recognition.EndSilenceTimeoutAmbiguous = 2000
            recognition.continuous = false; // Listen for a single utterance
            recognition.interimResults = false; // Only return final results
            recognition.lang = 'en-US'; // Set language

            recognition.onresult = (event) => {
                const transcript = event.results[0][0].transcript;
                setInputValue(transcript);
                // setTextInput(transcript)
                setIsListening(false);
            };

            recognition.onerror = (event) => {
                console.error('Speech recognition error:', event.error);
                setIsListening(false);
            };

            recognition.onend = async () => {
                setIsListening(false);

                await endAudio.play();

            };
        }
    }, [recognition]);

    useEffect(() => {
        if (inputValue) {
            handleSubmit({ textInput: inputValue, clientId: selectedClientId?.value, planId: selectedPlanId?.value })
            setInputValue('')
            //  setTextInput('')
        }
    }, [inputValue])

    const messagesEndRef = useRef(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]); // Dependency array: re-run effect when messages change

    const queryKey = ['list-all', threadId];

    const {
        data,
        refetch,
        fetchNextPage,
        fetchPreviousPage,
        isLoading, //first time only
        isFetching,

        hasNextPage,
        isFetched,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isError,
        status,
        error,

    } = useInfiniteQuery({
        retry: false,
        refetchOnWindowFocus: true,
        placeholderData: keepPreviousData,
        queryKey,
        queryFn: async ({ pageParam }) => {
            let url = `http://localhost:3001/chat/list`

            if (pageParam) {
                url += `?lastEvaluatedKey=${pageParam}`
            }

            const res = await fetch(url)

            if (!res.ok) throw new Error('Something went wrong');

            return await res.json()
        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.Items).flatMap((x) => x),
                pageParams: data.pageParams,
            };
            // return { ...data.hits, timestamp: Date.now() }
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.LastEvaluatedKey ? encodeURIComponent(JSON.stringify(lastPage.LastEvaluatedKey)) : null
        },

        staleTime: 0,//,Infinity,
        enabled: true  //&& !!showChat
    })

    const SIZE = 10

    const { data: clientOptions } = useQuery({
        queryKey: ['getAggs'],
        queryFn: async () => {

            const res = await fetch(`http://localhost:3001/opensearch/getAggs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    index: 'knowledge-base',
                    field: 'metadata.clientId.keyword',
                    size: 100
                })
            })

            if (!res.ok) {
                throw new Error('Something went wrong')
            }

            const results = await res.json()
            return results
        },
        select: (data) => {
            return data.aggregations['metadata.clientId.keyword']?.buckets.map(bucket => ({
                label: `${bucket.key} (${bucket.doc_count})`,
                value: bucket.key
            }))
        }
    })

    const { data: planOptions } = useQuery({
        queryKey: ['getAggs', selectedClientId],
        queryFn: async () => {

            const res = await fetch(`http://localhost:3001/opensearch/getAggs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    index: 'knowledge-base',
                    field: 'metadata.planId.keyword',
                    query: {
                        "term": {
                            "metadata.clientId.keyword": selectedClientId.value
                        }
                    }
                })
            })

            if (!res.ok) {
                throw new Error('Something went wrong')
            }

            const results = await res.json()
            return results
        },
        select: (data) => {
            return data.aggregations['metadata.planId.keyword']?.buckets.map(bucket => ({
                label: `${bucket.key} (${bucket.doc_count})`,
                value: bucket.key
            }))
        },
        enabled: !!selectedClientId
    })

    const handleSubmit = async (payload) => {

        try {
            const { textInput, threadId, clientId, planId } = payload
            console.log({ textInput, threadId, clientId, planId })
            setLoading(true)

            const content = textInput

            setMessages(prev => ([...prev, { id: crypto.randomUUID(), content }]))

            const response = await fetch('http://localhost:3001/chat', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ message: content, threadId, clientId, planId }),
            });

            if (!response.body) {
                throw new Error('No response body');
            }

            const reader = response.body.getReader();

            let newThreadId = threadId
            while (true) {
                const { value, done } = await reader.read();
                if (done) break;
                const text = decoder.decode(value);

                try {
                    const msgObj = JSON.parse(text.replace('data: ', ''));
                    newThreadId = msgObj.threadId
                    setMessages(prev => ([...prev, { id: crypto.randomUUID(), ...msgObj }]))
                } catch (e) {
                    console.error('Failed to parse JSON chunk:', e, text);
                }

            }
            if (!threadId) {
                navigate(newThreadId)
            }

        } catch (error) {
            setErrorMessage(error.message)
        }

        setLoading(false)
        return
    }

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const results = data?.pages.flat()
    const selected = results?.find(r => r?.threadId === threadId)

    useEffect(() => {
        if (selected) {
            setSelectedClientId({
                label: selected.clientId,
                value: selected.clientId,
            })

            setSelectedPlanId({
                label: selected.planId,
                value: selected.planId,
            })
        }

    }, [selected])

    const startListening = async () => {

        await startAudio.play();
        await commonUtils.delay(200);
        if (recognition) {
            setIsListening(true);
            recognition.start();
        } else {
            alert('Speech Recognition not supported in this browser.');
        }
    };

    const disableSubmission = isListening || loading

    const deleteItem = async (value) => {
        console.log('delete', value)
        const res = await fetch(`http://localhost:3001/check-pointer`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                threadId: value.threadId
            })
        })

        if (!res.ok) {
            throw new Error('Unable to delete chat')
        }
        await res.json()
        setMessages([])
        return
    }

    const mutationDeleteItem = useMutation({
        mutationFn: deleteItem,
        onSuccess: (data, variables) => {
            queryClient.setQueryData(queryKey, (oldData => {
                if (oldData) {
                    console.log(oldData)
                    for (let i = 0; i < oldData.pages.length; i++) {
                        let page = oldData.pages[i];
                        page.Items = page.Items.
                            filter(item => !(item.pk === variables.pk && item.sk === variables.sk))
                        //for update
                        // map((item) => {
                        //     if (item.pk === variables.pk && item.sk === variables.sk && data) {
                        //         item = { ...item, ...data }
                        //     }
                        //     return item;
                        // }).filter(x => x);

                        oldData.pages[i] = page;
                    }
                }
                return oldData
            }));

            navigate('/chatbots/plans')
        },
        onError: (err) => {
            console.log(err)
            // setError(err?.response?.data?.message || err.message)
        }
    })


    return (
        <div className="chat-container-wrapper">

            <div className="chat-side-bar">
                {<div style={{ display: 'flex', gap: '1rem', alignItems: 'center', padding: '0rem 1rem 1.4rem .8rem' }}>
                    <TbEdit size={'1.2rem'} />
                    <p style={{ cursor: 'pointer' }} onClick={() => {
                        setMessages([])
                        navigate('/chatbots/plans')

                    }}>
                        New Message</p>

                </div>}


                <p className="title" style={{ padding: '0rem .4rem 1rem 0.8rem ' }}>Chats</p>

                <div className="firstMessagePrefix-wrapper scrollable-form">
                    {isError && <p className="danger">{error?.message}</p>}
                    {results?.length ?
                        results?.map(result => {
                            return <div
                                key={result?.sk}
                                className={`firstMessagePrefix ${selected?.sk === result?.sk ? 'selected' : ''}`}
                                style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                <div onClick={async () => {
                                    navigate(result.threadId)
                                }} >

                                    <p style={{ color: 'var(--grey)', fontSize: '.8rem', padding: '0rem 0rem .4rem 0rem' }}>{result?.clientId} - {result?.planId}</p>
                                    <p>{result?.firstMessagePrefix}</p>
                                    <p>{result?.clientId}</p>
                                    <p style={{ color: 'var(--grey)', fontSize: '.8rem', padding: '.4rem 0rem' }}>{result?.createdAt}</p>
                                </div>
                                <div>
                                    <FaRegTrashCan style={{ cursor: 'pointer' }} color={"var(--red)"} onClick={() => { mutationDeleteItem.mutate(result) }} />

                                </div>


                            </div>
                        }) : <div>No chat history</div>}
                </div>


                <div style={{ padding: "1rem 0rem", display: isFetchingNextPage || hasNextPage ? "block" : "none" }}>
                    <button
                        ref={ref}
                        onClick={() => fetchNextPage()}
                        disabled={!hasNextPage || isFetchingNextPage}
                        className="clickable-link"
                        style={{ padding: ".4rem 1rem", backgroundColor: "var(--white)", border: "none" }}
                    >
                        {isFetchingNextPage ? "Loading more..." : hasNextPage ? "Load more" : "Done"}
                    </button>
                </div>
            </div>

            <div className="chat-container" >
                <div style={{ borderBottom: '1px solid var(--lighterGrey)', paddingBottom: threadId ? '0rem' : '1rem' }}>
                    {!threadId && <p style={{ padding: '1rem 1rem 0rem 1rem', fontWeight: 600, fontSize: '1.2rem' }}>Filters</p>}

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem', }}>

                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                            <Select
                                name={'Client'}
                                className="react-select-container large-input"
                                classNamePrefix="react-select"
                                placeholder={'Filter by Client'}
                                isDisabled={!!threadId}
                                options={clientOptions}
                                value={selectedClientId}
                                onChange={(option) => { setSelectedPlanId(null); setSelectedClientId(option) }}
                            />


                            {selectedClientId && planOptions?.length ? <Select
                                name={'Plan'}
                                className="react-select-container large-input"
                                classNamePrefix="react-select"
                                placeholder={'Filter by Plan'}
                                isDisabled={!!threadId}
                                options={planOptions}
                                value={selectedPlanId}
                                onChange={(option) => { setSelectedPlanId(option); }}
                            /> : <></>}



                        </div>
                    </div>

                    {!threadId && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0rem 1rem ', }}>
                        <p style={{ cursor: 'pointer', color: 'var(--red)' }}
                            onClick={() => {
                                setSelectedClientId(null)
                                setSelectedPlanId(null)


                            }}
                        >Clear filters</p>
                    </div>}



                </div>



                {!messages?.length ? <>
                    <div className="chat-title"
                        style={!messages?.length ? {
                            display: 'grid',
                            flex: 1,
                            placeItems: 'center',

                        } : {}}>
                        <div style={{ textAlign: 'center' }}>
                            <p
                                style={!messages?.length ? {
                                    fontSize: '2rem',
                                    fontWeight: '600'
                                } : {}}> {'Hi '} </p>
                            <span style={{ fontSize: '1rem' }}>How can I help you?</span>
                        </div>
                    </div>
                </> : <>
                    {/* {threadId && <div style={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        backgroundColor: 'var(--lightestGrey)',
                        // backdropFilter: 'blur(10px)',
                        padding: '1rem'
                    }}>
                        <p style={{ fontSize: '.8rem', fontWeight: '600' }}>Thread ID: {threadId}</p>
                        <p style={{ fontSize: '.8rem', color: 'var(--red)', cursor: 'pointer' }}
                            onClick={() => {
                                // setMessages([])
                                setTextInput('')
                                mutationDeleteItem.mutate(selected)
                            }}>Delete</p>

                    </div>} */}

                    {/* {chatDetails && <ReactJson
                        style={{ padding: "1rem" }}
                        src={chatDetails}
                        name={false}
                        collapsed={false}
                        collapseStringsAfterLength={150}
                        displayDataTypes={false}
                        displayObjectSize={false}
                        sortKeys={false}
                    />} */}


                    <div className="chat-messages" >
                        {messages?.
                            // filter(msg => !msg?.tool).
                            // filter(msg => !msg?.tools).
                            map(message => {

                                // return <ReactJson
                                //     style={{ padding: "1rem" }}
                                //     src={message}
                                //     name={false}
                                //     collapsed={false}
                                //     collapseStringsAfterLength={150}
                                //     displayDataTypes={false}
                                //     displayObjectSize={false}
                                //     sortKeys={false}
                                // />

                                if (message?.agent?.messages?.[0].id.includes('SystemMessage')) return
                                const aiMessage = message?.agent?.messages?.[0]?.kwargs //|| message?.supervisor?.messages?.[0]?.kwargs || message?.member_search_agent?.messages?.[0]?.kwargs || message?.calculate_age_agent?.messages?.[0]?.kwargs;
                                const toolMessage = message?.tool?.messages?.[0]?.kwargs;
                                const isHumanMessage = message?.content
                                const content = aiMessage?.content?.[0]?.text || aiMessage?.content || message?.content

                                if (!content) return
                                return <div className="chat-message-box" key={(aiMessage?.id || message.id) + Math.random()} >
                                    {/* <ReactJson
                                        style={{ padding: "1rem" }}
                                        src={message}
                                        name={false}
                                        collapsed={true}
                                        collapseStringsAfterLength={150}
                                        displayDataTypes={false}
                                        displayObjectSize={false}
                                        sortKeys={false}
                                    /> */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            width: '100%',
                                            alignItems: `center`,
                                            justifyContent: `${message?.content ? 'end' : 'start'}`
                                        }}>


                                        {/* 
                                        {JSON.stringify(message.usage_metadata)} */}
                                        {isHumanMessage ? <HumanMessage content={message?.content} /> : <AIMessage content={content} />}



                                    </div>
                                </div>
                            })}
                        <div ref={messagesEndRef} />
                    </div>
                </>}

                {
                    loading || navigation.state === "loading" ? <div style={{ padding: '1rem', display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                        <div className="loader" ></div>
                    </div> : <></>
                }
                {errorMessage && <p className="danger" style={{ padding: '1rem' }}>{errorMessage}</p>}

                <ChatInput
                    threadId={threadId}
                    clientId={selectedClientId?.value}
                    planId={selectedPlanId?.value}
                    handleSubmit={handleSubmit}
                    disableInput={!(selectedClientId)} //&& selectedPlanId
                    placeholder={selectedClientId ? 'Start typing' : disableSubmission ? 'Sending' : 'Please select a client'}
                    disableSubmission={disableSubmission}
                    startListening={startListening}
                />

            </div >

        </div >
    )
}

export default FinanceChatbot
